@if ( activateEditor ) {
<mat-icon type='button' mat-flat-button [title]="props?.label + ' settings'"
    [matMenuTriggerFor]='settingsMenu' [matMenuTriggerData]="{field: field}" [matBadge]="props?.position"
    matBadgePosition='above after' matBadgeOverlap=true matBadgeSize='small' [ngClass]="{'settings-icon': true}"
    (click)="menuEditor($event)" >
    settings</mat-icon>
}
<ng-container #fieldComponent></ng-container>

<mat-menu #settingsMenu='matMenu' class='cdk-drag-preview'>
    <ng-template matMenuContent let-field='field'>
        <div mat-menu-item class='subtitle'>Settings {{field.props.label || field.props.key}}</div>
        @for ( config of fieldConfigs; track config.key ) {
        <div mat-menu-item>{{config.props.label}}&hellip;</div>
        }
    </ng-template>
</mat-menu>